import React from "react";
import { useTranslation } from "react-i18next";

const ChatbotOptions = ({ actionProvider, state }) => {
  const { t } = useTranslation();
  return (
    <div className="chatbot-options-container">
      <button
        className="btn btn-outline-primary btn-sm"
        onClick={() => {
          actionProvider.helpAPI();
        }}
      >
        {t("Yes")}
      </button>
      <button
        className="btn btn-outline-primary btn-sm"
        onClick={() => {
          actionProvider.contactUs(state?.messages[3]?.message);
        }}
      >
        {t("No")}
      </button>
    </div>
  );
};

export default ChatbotOptions;
